



































import { Component, Prop, Vue } from "vue-property-decorator";
import store from "@/store";
import { MutationsTypes } from "../../store/modules/delayCodes/mutations";

@Component
export default class ExpertHeader extends Vue {
  @Prop(Boolean) readonly visible!: boolean;

  goToGuidedMode = () => {
    store.commit.delayCodes[MutationsTypes.RESET_SELECTION]();
    this.$router.push("guided");
  };

  textChanged = (text: string) => {
    store.commit.delayCodes[MutationsTypes.EXPERT_SET_CODE](text);
  };
}
